import axios from "axios";
import { API_URL } from "./../../utils/api-utils";
import { common } from "./../../utils";

// Portal
export const GetModuleMasterList = async (param) => {
  let url = `${API_URL.Lobby}/api/Portal/GetModuleMasterList`;
  let { result } = await common.to(axios.post(url, param));
  if (result && result.data) return result.data;
};

export const GetRolesList = async (param) => {
  let url = `${API_URL.Lobby}/api/Portal/GetRolesList`;
  let { result } = await common.to(axios.post(url, param));
  if (result && result.data) return result.data;
};

// Master
export const GetListEncrypType = async (param) => {
  let url = `${API_URL.Loader}/api/master/GetListEncrypType`;
  let { result } = await common.to(axios.post(url, param));
  if (result && result.data) return result.data;
};

export const GetValidateType = async (param) => {
  let url = `${API_URL.Loader}/api/master/GetValidateType`;
  let { result } = await common.to(axios.post(url, param));
  if (result && result.data) return result.data;
};

export const GetVerticaConfig = async (param) => {
  let url = `${API_URL.Loader}/api/master/GetVerticaConfig`;
  let { result } = await common.to(axios.post(url, param));
  if (result && result.data) return result.data;
};

export const GetSystemConfig = async (param) => {
  let url = `${API_URL.Loader}/api/master/GetSystemConfig`;
  let { result } = await common.to(axios.post(url, param));
  if (result && result.data) return result.data;
};
